// Dataset download request actions
export const DATASET_DOWNLOAD_REQUEST_SEND = 'DATASET_DOWNLOAD_REQUEST_SEND';
export const DATASET_DOWNLOAD_REQUEST_SUCCESS =
  'DATASET_DOWNLOAD_REQUEST_SUCCESS';
export const DATASET_DOWNLOAD_REQUEST_FAILURE =
  'DATASET_DOWNLOAD_REQUEST_FAILURE';
export const DATASET_DOWNLOAD_REQUEST_PROCESSING =
  'DATASET_DOWNLOAD_REQUEST_PROCESSING';

// Query size check actions
export const CHECK_QUERY_SIZE_SEND = 'CHECK_QUERY_SIZE_SEND';
export const SET_CHECK_QUERY_SIZE_REQUEST_STATE = 'SET_CHECK_QUERY_SIZE_STATE';
export const STORE_CHECK_QUERY_SIZE_RESULT = 'STORE_CHECK_QUERY_SIZE_RESULT';
export const CLEAR_FAILED_SIZE_CHECKS = 'CLEAR_FAILED_SIZE_CHECKS';
